<template>
  <hcm-card
    :resource="resource"
    :cardImage="resource.image"
    :cardTitle="resource.title"
    :resourceUrl="resource.slug"
    :externalResource="true"
    :cardText="resource.description"
    :hasSource="false"
    :hasShare="false"
  ></hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  }
};
</script>
